module.exports = __webpack_public_path__ + "static/assets/e53bee95de9d4336622ad3111f9ab991.svg";